/**
 * FASWORLD flash sale countdown
 */
(() => {
  const nodes = document.querySelectorAll('[data-fw-countdown]');
  if (!nodes.length) return;

  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

  const tick = (el) => {
    const ends = Date.parse(el.dataset.endsAt || '');
    const display = el.querySelector('[data-fw-countdown-display]');
    if (!ends || Number.isNaN(ends) || !display) return false;

    const diff = ends - Date.now();
    if (diff <= 0) {
      el.classList.add('is-expired');
      return false;
    }

    const total = Math.floor(diff / 1000);
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    const map = { days, hours, minutes, seconds };
    display.querySelectorAll('[data-unit]').forEach((node) => {
      const unit = node.getAttribute('data-unit');
      if (unit && map[unit] != null) node.textContent = pad(map[unit]);
    });
    return true;
  };

  nodes.forEach((el) => {
    if (!tick(el)) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    window.setInterval(() => tick(el), 1000);
  });
})();
